module.exports = __webpack_public_path__ + "assets/img/4_123_big.ee4cf605.jpg";